export const FLAGGED_REASON = {
	S2S_INVALID_RESPONSE: 1,
	SCAN_FAILED: 2,
	LOW_CR: 3,
	HIGH_REJECT_RATE: 4,
	HIGH_BLOCK_RATE: 5,
	NO_INSTALLS: 6,
	DUPLICATE_FLAGGED_OFFER: 7,
	KPI_RULE: 8,
};

export const FLAGGED_REASON_LABELS = {
	[FLAGGED_REASON.S2S_INVALID_RESPONSE]:
		"Valid S2S response ratio below 20% over the last 4 hours",
	[FLAGGED_REASON.SCAN_FAILED]: "Auto scan failed to land in store",
	[FLAGGED_REASON.LOW_CR]: "Low CR",
	[FLAGGED_REASON.HIGH_REJECT_RATE]: "High rejection rate",
	[FLAGGED_REASON.HIGH_BLOCK_RATE]: "High blocked rate",
	[FLAGGED_REASON.NO_INSTALLS]: "No installs with high traffic volume",
	[FLAGGED_REASON.DUPLICATE_FLAGGED_OFFER]:
		"Duplicate of flagged distributed MMP account offer",
	[FLAGGED_REASON.KPI_RULE]: "KPI rule triggered",
};

export const UNFLAGGABLE_PLACEMENT_REASONS = [FLAGGED_REASON.SCAN_FAILED];

export function getFlaggedReasonLabel(reason, fallback = "Flagged") {
	// Resolve an integer flag reason code (or legacy text) to its display label.
	if (reason !== null && reason !== undefined && reason !== "") {
		const code = Number(reason);
		if (Number.isInteger(code) && FLAGGED_REASON_LABELS[code]) {
			return FLAGGED_REASON_LABELS[code];
		}
		if (typeof reason === "string" && Number.isNaN(code)) {
			return reason;
		}
	}
	return fallback;
}

export function canRecheckPlacementFlag(placement) {
	// Check whether the placement is flagged with a reason that supports manual recheck.
	if (!placement || !placement.is_flagged) {
		return false;
	}
	return UNFLAGGABLE_PLACEMENT_REASONS.includes(Number(placement.flagged_reason));
}
